import React from 'react'
// import Layout from '../Layout/Layout'
import { Link } from 'react-router-dom'
import Layout from '../componentes/Layout'
const Pagenotfound = () => {
  return (
    <Layout  title={'Go back - Page Not Found'}>
      <div className='pnf'>
        <h1 className='pnf-title'>404</h1>
        <h2 className='pnf-heading'>Oops ! Page Not Found</h2>
        <Link to='/' className='pnf-btn'>
          Go Back
        </Link>
      </div>
    </Layout>
  )
}

export default Pagenotfound